<header>
    <img class="avatar" src="../assets/images/avatar.jpg" alt="Avatar Anouska de Graaf" />
    <h1>Anouska de Graaf</h1>
</header>